/* eslint no-param-reassign: 0 */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AgentModel } from '../model/agent.model'

interface ErrorInterface {
  errorMessage: string
  errorCode: string
}

export type AgentState = {
  loading: boolean | null
  errorCode: string
  errorMessage: string
  data: AgentModel | Record<string, any>
}

export const initialState: AgentState = {
  data: {},
  errorMessage: '',
  errorCode: '',
  loading: null,
}

export const agentSlice = createSlice({
  name: 'agent',
  initialState,
  reducers: {
    fetchAgentData() {
      return { ...initialState, loading: true }
    },
    fetchAgentDataSuccess(_state, action: PayloadAction<AgentModel>) {
      const { payload } = action
      return { ...initialState, data: payload }
    },
    fetchAgentDataError(_state, action: PayloadAction<ErrorInterface>) {
      const {
        payload: { errorMessage, errorCode },
      } = action
      return { ...initialState, errorCode, errorMessage }
    },
    resetAgentData: () => initialState,
  },
})

export const {
  fetchAgentData,
  fetchAgentDataSuccess,
  fetchAgentDataError,
  resetAgentData,
} = agentSlice.actions

const agentReducer = agentSlice.reducer
export default agentReducer
